import { GetterTree } from 'vuex';
import { RootState } from '../../types';
import { ApplicationUserPermissionsState } from './types';

export const getters: GetterTree<ApplicationUserPermissionsState, RootState> = {
  ['getCurrentPermissions']: state => state.currentPermissions,
  ['getCurrentUserId']: state => state.currentUserId,
  ['permissionsIsLoading']: state => state.isLoading,
};
